module.exports = "https://redage.akamaized.net/src/views/donate/main/elements/shop/img/sapper.png";